/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Sport
 */
export interface Sport {
    /**
     * 
     * @type {string}
     * @memberof Sport
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Sport
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Sport
     */
    key: string;
}

/**
 * Check if a given object implements the Sport interface.
 */
export function instanceOfSport(value: object): value is Sport {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function SportFromJSON(json: any): Sport {
    return SportFromJSONTyped(json, false);
}

export function SportFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sport {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'key': json['key'],
    };
}

export function SportToJSON(value?: Sport | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'key': value['key'],
    };
}

